export const apiKey = {
  "mapbox": 'pk.eyJ1IjoiZG9uZ2ZmIiwiYSI6ImNtZTJrdmlnajBzZTYycXB1ajJraWZqN2EifQ.pQ5hX_TXMYlAqCdoH8xXzQ',
  "MapTiler": 'ULjYXDQ80Sa0Sz9NhVxr',
  "TomTom": 'JKdrjUkBoPKdxms39deimKP7G88HOus7',
  "WindyMapForecast": "WmxtYslNzVe1jVmLiUpsTLg38x6zCwJz",
  "WindyPointForecast": "L52fwHJOspVoCANQISqvcW8ioomfVEn2",
  "esri": "AAPTxy8BH1VEsoebNVZXo8HurACzEcbxs1CM6qvSsCfLXNQ1k-M-mO1tfawnx5l64o7JIt5xzfQt9d3o2Q7yhsna8GSPgWTmk-dD2daCgjoVwJP2bD0PFNlhjfxiYC5gdgeiI860FlXOzlbQUbqdmQRcwvNk5Z6x8W-Hq3B9RY_YRZ4XDcLsjU1OM0B4RCDv4yOUq_kHy8yg25R0YbXmtgsakirOwcAz_kEA7M_a8nafFOs.AT1_E7R0FWSI",
  "x-api-key": "LyjdSkL78IxYwPH1I9xScetE9qft",
};
export const baseApiUrl = `https://0756eapi5l.execute-api.us-east-1.amazonaws.com/p/`;